import { render, staticRenderFns } from "./policy-KR.vue?vue&type=template&id=7445a3ac&"
import script from "./policy-KR.vue?vue&type=script&lang=js&"
export * from "./policy-KR.vue?vue&type=script&lang=js&"
import style0 from "./policy-KR.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports